import React from 'react';
import Icon from '../../../components/AppIcon';

const EventTimeline = () => {
  const timelineSteps = [
    {
      id: 1,
      icon: 'Send',
      title: 'Submit Your Inquiry',
      description: 'Fill out our detailed catering form with your event requirements, guest count, and preferences.',
      duration: 'Day 1',
      color: 'primary'
    },
    {
      id: 2,
      icon: 'Phone',
      title: 'Initial Consultation',
      description: 'Our catering specialist contacts you to discuss your vision, dietary needs, and budget considerations.',
      duration: 'Within 24 hours',
      color: 'accent'
    },
    {
      id: 3,
      icon: 'FileText',
      title: 'Custom Proposal',
      description: 'Receive a detailed proposal with menu options, pricing breakdown, and service recommendations.',
      duration: '2-3 business days',
      color: 'success'
    },
    {
      id: 4,
      icon: 'Users',
      title: 'Menu Tasting',
      description: 'Schedule a complimentary tasting session to sample dishes and finalize your selections.',
      duration: 'Optional',
      color: 'warning'
    },
    {
      id: 5,
      icon: 'CheckCircle',
      title: 'Confirmation',
      description: 'Review and approve final details, sign contract, and secure your event date with deposit.',
      duration: '1 week before event',
      color: 'primary'
    },
    {
      id: 6,
      icon: 'Truck',
      title: 'Event Preparation',
      description: 'Our team prepares fresh items, coordinates logistics, and confirms setup timeline with venue.',
      duration: '2-3 days before',
      color: 'accent'
    },
    {
      id: 7,
      icon: 'ChefHat',
      title: 'Event Day Setup',
      description: 'Professional team arrives early for setup, food preparation, and final quality checks.',
      duration: 'Event day morning',
      color: 'success'
    },
    {
      id: 8,
      icon: 'Sparkles',
      title: 'Flawless Service',
      description: 'Enjoy seamless catering service while our team handles everything from serving to cleanup.',
      duration: 'During event',
      color: 'warning'
    }
  ];

  return (
    <section className="py-16 bg-background">
      <div className="container-custom">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 mb-4">
            <Icon name="Clock" size={18} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">Our Process</span>
          </div>
          <h2 className="font-serif text-4xl font-bold text-foreground mb-4">
            Your Event Journey with Montesanto
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From first contact to final cleanup, we handle every detail with precision and care
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-accent to-success hidden md:block" />

            <div className="space-y-8">
              {timelineSteps?.map((step, index) => (
                <div
                  key={step?.id}
                  className="relative flex gap-6 group"
                >
                  <div className="hidden md:flex flex-col items-center flex-shrink-0">
                    <div className={`w-16 h-16 rounded-full bg-${step?.color}/10 flex items-center justify-center border-4 border-background shadow-warm group-hover:scale-110 transition-transform duration-300`}>
                      <Icon name={step?.icon} size={24} color={`var(--color-${step?.color})`} />
                    </div>
                    {index < timelineSteps?.length - 1 && (
                      <div className="w-0.5 h-full bg-border mt-2" />
                    )}
                  </div>

                  <div className="flex-1 bg-card rounded-2xl shadow-warm p-6 hover:shadow-warm-lg transition-all duration-300">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center gap-3">
                        <div className="md:hidden w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                          <Icon name={step?.icon} size={20} color={`var(--color-${step?.color})`} />
                        </div>
                        <div>
                          <h3 className="font-serif text-xl font-bold text-foreground">
                            {step?.title}
                          </h3>
                          <span className={`text-sm font-medium text-${step?.color}`}>
                            {step?.duration}
                          </span>
                        </div>
                      </div>
                      <div className={`px-3 py-1 rounded-full bg-${step?.color}/10 text-${step?.color} text-sm font-medium`}>
                        Step {step?.id}
                      </div>
                    </div>
                    <p className="text-muted-foreground leading-relaxed">
                      {step?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 p-4 bg-card rounded-lg shadow-warm">
            <Icon name="Clock" size={20} color="var(--color-primary)" />
            <p className="text-sm text-foreground">
              <strong>Average Timeline:</strong> From inquiry to event day typically takes 2-4 weeks. Rush orders available for urgent events.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventTimeline;